import styled from 'styled-components';

import { ColoredButton, Div } from 'common/styles/oc-styled-components';
import { BREAKPOINTS, colors } from 'common/styles/style-constants';

export const BookingWidgetContainer = styled(Div)`
  max-width: 325px;
  margin: 0 0 0 30px;
`;

export const ProfileSection = styled.section`
  margin: 60px 0 0;

  @media (max-width: ${BREAKPOINTS.tabletMax}px) {
    width: 100%;
  }

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    max-width: 100%;
    margin: ${(props) => (props.mobileMargin ? props.mobileMargin : '10px 0')};
    padding: 10px;
  }
`;

export const SectionDivider = styled.hr`
  border: 0.5px solid ${colors.silver};
  margin: 60px -200% 0;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    margin: 20px 0;
  }
`;

export const MobileRequestButton = styled(ColoredButton)`
  && {
    position: fixed;
    bottom: -5em;
    width: 92%;
    margin-bottom: 1em;
    transition: bottom 600ms ease-in;
    border: none;
    z-index: 1;
    &.slideUp {
      bottom: 0;
    }
  }
`;

export const MobileRequestAppointmentBtnContainer = styled(Div)`
  && {
    position: fixed;
    bottom: 0;
    padding: 15px;
    width: 100%;
    &.show {
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0,
        ${colors.white} 100%
      );
    }
  }
`;

export const ProfileLoadingScreen = styled(Div)`
  background: ${colors.nickel};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  min-height: 100vh;
  font-size: 50px;
`;
